export const GENERAL_RULES_KEY = 'game0';

export const RAYMOND_UID = 'uGqTXpxQHzg4K7DRhObVWvValvF3';